<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <div class="content">
            <div class="selection-wrapper">
                <!-- Link Type Selection -->
                <div class="form-group">
                    <label>Link Type</label>
                    <nb-radio-group [(ngModel)]="selectedLinkType" (ngModelChange)="onLinkTypeChange($event)">
                        <nb-radio [value]="'TEXT'">{{ linkTypeEnum.TEXT }}</nb-radio>
                        <nb-radio [value]="'BUTTON'">{{ linkTypeEnum.BUTTON }}</nb-radio>
                        <nb-radio [value]="'ICON'">{{ linkTypeEnum.ICON }}</nb-radio>
                    </nb-radio-group>
                </div>
                <!-- Link Text Input -->
                <div class="form-group inline">
                    <label for="linkText">Link Text</label>
                    <input nbInput fullWidth id="linkText" [(ngModel)]="text" (ngModelChange)="onTextChange($event)"
                        placeholder="Enter link text">
                </div>
            </div>
            <div class="selection-wrapper">
                <!-- Action/Target Selection -->
                <div class="form-group">
                    <label>Link Target</label>
                    <nb-radio-group [(ngModel)]="selectedAction" (ngModelChange)="onActionChange($event)">
                        <nb-radio [value]="'PRODUCT'">{{ linkTargetEnum.PRODUCT }}</nb-radio>
                        <nb-radio [value]="'CATEGORY'">{{ linkTargetEnum.CATEGORY }}</nb-radio>
                        <nb-radio [value]="'ARTICLE'">{{ linkTargetEnum.ARTICLE }}</nb-radio>
                    </nb-radio-group>
                </div>
                <div class="selected-option-wrapper">
                    <!-- Product ID Lookup (shown when PRODUCT is selected) -->
                    <div class="form-group" *ngIf="selectedAction === 'PRODUCT'">
                        <label for="productIdLookup">Product ID</label>
                        <div class="lookup-field">
                            <input type="hidden" nbInput fullWidth id="productIdLookup" [(ngModel)]="productId"
                                [disabled]="true" placeholder="Select a product">
                            <ubs-ofbiz-textqbe-field [formField]="formField" (setLookupField)="setTextQBEField($event)"
                                (openTextQBEDialogEvent)="openTextQBEDialog($event)"></ubs-ofbiz-textqbe-field>
                            <button nbButton status="primary" size="small" (click)="openProductLookupDialog()">
                                Search
                            </button>
                        </div>
                    </div>
                    <!-- Category ID Lookup (shown when CATEGORY is selected) -->
                    <div class="form-group" *ngIf="selectedAction === 'CATEGORY'">
                        <label for="categoryIdLookup">Category ID</label>
                        <div class="lookup-field">
                            <input type="hidden" nbInput fullWidth id="categoryIdLookup" [(ngModel)]="categoryId"
                                [disabled]="true" placeholder="Select a category">
                            <ubs-ofbiz-textqbe-field [formField]="formField" (setLookupField)="setTextQBEField($event)"
                                (openTextQBEDialogEvent)="openTextQBEDialog($event)"></ubs-ofbiz-textqbe-field>
                            <button nbButton status="primary" size="small" (click)="openCategoryLookupDialog()">
                                Search
                            </button>
                        </div>
                    </div>
                    <!-- Article ID Lookup (shown when ARTICLE is selected) -->
                    <div class="form-group" *ngIf="selectedAction === 'ARTICLE'">
                        <label for="articleIdLookup">Article ID</label>
                        <div class="lookup-field">
                            <input type="hidden" nbInput fullWidth id="articleIdLookup" [(ngModel)]="articleContentId"
                                [disabled]="true" placeholder="Select an article">
                            <ubs-ofbiz-textqbe-field [formField]="formField" (setLookupField)="setTextQBEField($event)"
                                (openTextQBEDialogEvent)="openTextQBEDialog($event)"></ubs-ofbiz-textqbe-field>
                            <button nbButton status="primary" size="small" (click)="openArticleLookupDialog()">
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Action Buttons -->
            <div class="action-buttons">
                <button nbButton status="primary" (click)="onSave()">Save</button>
                <button nbButton status="basic" (click)="onCancel()">Cancel</button>
            </div>
        </div>

    </div>
</div>